import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { VolunteerSpecialistSignup } from '../specialist-signups-dialog.part';
import { getColumns } from './get-columns';

export function getSetup(util: UtilityService): GridSetup<VolunteerSpecialistSignup> {

	return {
		rowName: { singular: 'Specialist Sign-up', plural: 'Specialist Sign-ups' },
		getRowKey: row => '' + row.trimesterId + '_' + row.topicName,
		stateKey: 'volunteer-dialog-specialist-signups-grid',
		actions: [],
		buttons: [],
		columns: getColumns(util),
	}
}
